<template>
  <header id="site-header">
    <div class="box">
      <figure class="logo">
        <a href="/">
          <img src="/images/common/logo.webp" alt="logo" />
        </a>
      </figure>
      <div class="menu">
        <nav role="navigation" itemscope="itemscope" itemtype="http://scheme.org/SiteNavigationElement">
          <ul>
            <li itemprop="name"><a itemprop="url" href="#gudebook">ガイドブック</a></li>
            <li itemprop="name"><a itemprop="url" href="#sponsorship">協賛募集</a></li>
            <li itemprop="name"><a itemprop="url" href="#performers">出演者・出店者募集</a></li>
            <li itemprop="name"><a itemprop="url" href="#list">協賛者一覧</a></li>
          </ul>
        </nav>
        <div class="meta">
          <dl>
            <dt>前夜祭</dt>
            <dd>8月15日(土)</dd>
          </dl>
          <dl>
            <dt>本祭</dt>
            <dd>8月16日(日)</dd>
          </dl>
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
header{
  width: 100%;
  position: fixed;
  padding: .72rem module.side();
  background: module.$white;
  border-bottom: module.$border 1px solid;
  z-index: 1000;
  @media screen and (max-width: module.$tab){
    position: absolute;
  }
  .box{
    max-width: module.$max;
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto auto;
    @media screen and (max-width: module.$tab){
      grid-template-columns: auto 1fr;
    }
    > *{
      align-self: center;
    }
  }
  .logo{
    width: 9.6rem;
    justify-self: flex-start;
    img{
      width: 100%;
    }
  }
  .menu{
    display: grid;
    grid-template-columns: 1fr auto;
    @media screen and (max-width: module.$tab){
      grid-template-columns: 1fr;
    }
    nav{
      justify-self: flex-end;
      align-self: center;
      @media screen and (max-width: module.$tab){
        display: none;
      }
      ul{
        @include module.flex();
        justify-content: center;
        align-items: center;
        li{
          font-size: 1.04rem;
          margin: 0 0 0 2rem;
          a{
            &:hover{
              color: module.$red;
            }
          }
          &:first-child{
            margin: 0;
          }
        }
      }
    }
    .meta{
      justify-self: flex-end;
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 1.6rem;
      margin: 0 0 0 2.4rem;
      padding: 0 0 0 2.4rem;
      border-left: module.$border 1px solid;
      @media screen and (max-width: module.$tab){
        margin: 0;
        padding: 0;
        border: none;
      }
      @media screen and (max-width: module.$phone){
        gap: .8rem;
      }
      dl{
        justify-self: flex-start;
        align-self: center;
        display: grid;
        grid-template-columns: 4rem auto;
        gap: .8rem;
        @media screen and (max-width: module.$phone){
          grid-template-columns: 1fr;
          gap: .24rem;
        }
        &:last-of-type{
          dt{
            background: module.$red;
          }
        }
        > *{
          align-self: center;
        }
        dt{
          font-size: .92rem;
          background: module.$yellow;
          color: module.$white;
          text-align: center;
          border-radius: .24rem;
          padding: .12rem 0;
        }
        dd{
          font-size: 1.12rem;
        }
      }
    }
  }
}
</style>

<script>
import Btn from './Btn.vue'
export default {
  components: {
    Btn: Btn,
  },
}
</script>
